@if (customer$ | async; as customer) {
  <agr-page-toolbar
    [pageTitle]="
      ('manureSubstances' | translate) + ' ' + customer?.name + ' ' + customer?.externalId
    "
    [stickyToolbar]="true"
    [stickyDetails]="true"
    [isEmpty]="hasNoData()"
    [emptyTitle]="'noManureSpaceTitle' | translate"
    [emptyDescription]="'noManureSpaceDescription' | translate"
    emptyActionIcon="navigate_next"
    [showEmptyAction]="true"
    [emptyActionText]="'fieldPlan' | translate"
    (emptyAction)="openFieldPlan()"
    [hasPrimaryAction]="true"
    primaryActionIcon="add"
    primaryActionText="add"
    (primaryAction)="addFertilizer()"
    [buttonItems]="hasNoData() ? [] : buttonItems"
    (buttonAction)="buttonAction($event)"
    [hasSecondaryAction]="hasSecondaryAction$ | async"
    [secondaryActionIcon]="secondaryActionIcon$ | async"
    [secondaryActionText]="'customerProgressManure' | translate"
    (secondaryAction)="secondaryAction()"
  >
    @if (!hasNoData()) {
      <div details class="spacing--padding-vertical">
        <app-fertilization-legal-standards-quick-view></app-fertilization-legal-standards-quick-view>
      </div>
    }
    <div displayAlways class="fertilizers-toolbar-row layout--margin-top">
      <div class="wrapper--spacing-horizontal filter-container">
        <agr-filter [config]="filterConfig" [showResetFilters]="false"></agr-filter>
      </div>
      <div class="fertilizers-tabs">
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          [selectedIndex]="activeTabIndexValue()"
          (selectedTabChange)="onTabChange($event)"
        >
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="tab-label">{{ 'fertilizers.tabs.ManureType' | translate }}</span>
            </ng-template>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="tab-label">{{ 'fertilizers.tabs.Period' | translate }}</span>
            </ng-template>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="tab-label">{{ 'fertilizers.tabs.ManureDetails' | translate }}</span>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
    @if (currentTabLoading()) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <span>{{ 'loading' | translate }}</span>
      </div>
    } @else {
      @if (activeTabIndex() === TabType.ManureType) {
        @if ((manureTypeResource$ | async)?.state === 'error') {
          <div class="error-message">
            {{ 'error.loading' | translate }}
          </div>
        } @else {
          <app-manure-type
            [fertilizers]="manureSpaceByManureCodes?.fertilizers ?? []"
            [isLoaded]="!!manureSpaceByManureCodes"
          />
        }
      }
      @if (activeTabIndex() === TabType.ManurePeriod) {
        @if ((manurePeriodResource$ | async)?.state === 'error') {
          <div class="error-message">
            {{ 'error.loading' | translate }}
          </div>
        } @else {
          <app-manure-period
            [fertilizers]="manureSpaceByPeriodData?.fertilizers ?? []"
            [isLoaded]="!!manureSpaceByPeriodData"
          />
        }
      }
      @if (activeTabIndex() === TabType.ManureDetails) {
        @if ((manureSpaceResource$ | async)?.state === 'error') {
          <div class="error-message">
            {{ 'error.loading' | translate }}
          </div>
        } @else {
          <app-manure-details
            [fertilizers]="manureDetailsData?.fertilizers ?? []"
            [isLoaded]="!!manureDetailsData"
          />
        }
      }
    }
  </agr-page-toolbar>
}
